import { Link } from 'react-router-dom';
import DramaCard from '@/components/feature/DramaCard';
import { dramas } from '@/mocks/dramas';

const featured = [...dramas].sort((a, b) => b.hot - a.hot).slice(0, 4);

export default function FeaturedDramas() {
  return (
    <section id="featured" className="w-full bg-background-100 border-y border-background-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.25em] text-primary-600 mb-3">
              TRENDING DOSSIERS / 热门档案
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              最近被问得最多的四部爆料短剧
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              按站内检索热度排序。点开任意一部，就能看到它的取材来源、原型人物对照和逐条改编分析。
            </p>
          </div>
          <Link
            to="/dramas"
            className="self-start md:self-auto inline-flex items-center gap-2 px-5 py-3 rounded-md border border-foreground-950/15 text-sm text-foreground-900 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 186 部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featured.map((drama, idx) => (
            <div key={drama.id} className="animate-fade-up" style={{ animationDelay: `${idx * 80}ms` }}>
              <DramaCard drama={drama} rank={idx + 1} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}